import { render, staticRenderFns } from "./UpdateResourceConfig.vue?vue&type=template&id=32084dbf&"
import script from "./UpdateResourceConfig.vue?vue&type=script&lang=js&"
export * from "./UpdateResourceConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports